<!-- customer-master.component.html -->
<div class="card">
  <div class="card-header">
    <h4>Customer List</h4>
  </div>

  <div class="card-body m-0">
    <div class="row mb-2">
      <div class="col-xl-10">

        <button type="button" class="btn bg-danger-custom"
                *ngIf="permissions.includes('Search')"
                (click)="onExportCSV()">
          <i class="feather icon-download me-2"></i>Export Excel
        </button>

        <button type="button" class="btn bg-danger-custom"
                (click)="quickFilterShowAction($event)">
          <i class="feather icon-filter me-2"></i>Quick Filters
        </button>

        <div class="btn-group mb-1 mb-md-0">
          <div class="btn-group" ngbDropdown role="group">
            <button class="btn bg-danger-custom" ngbDropdownToggle>
              <i class="feather icon-columns me-2"></i>Columns
            </button>

            <div ngbDropdownMenu class="column-dropdown p-2">

              <!-- Select/Clear controls -->
              <div class="d-flex justify-content-between align-items-center mb-2">
                <button type="button"
                        class="btn btn-sm btn-warning"
                        (click)="selectAllColumns()">
                  Select All
                </button>

                <button type="button"
                        class="btn btn-sm btn-secondary"
                        (click)="clearAllColumns()">
                  Clear All
                </button>
              </div>

              <!-- Search box -->
              <div class="mb-2">
                <input class="form-control form-control-sm"
                       placeholder="Search columns..."
                       [(ngModel)]="columnSearchText" />
              </div>

              <!-- Column list -->
              <div *ngIf="filteredColumns?.length" class="list-group column-list">
                <label *ngFor="let column of filteredColumns"
                       class="list-group-item column-item"
                       [class.column-item-disabled]="column.field === 'actions'">

                  <span class="column-label">
                    {{ (column?.headerName?.replace('_','') || column?.field?.replace('_','')) }}
                  </span>

                 <input class="column-checkbox"
                    type="checkbox"
                    [checked]="isColumnSelected(column)"
                    [disabled]="column.field === 'actions'"
                    (click)="$event.stopPropagation()"
                    (change)="onColumnCheckboxChange(column, $event)" />
                </label>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Quick filters -->
    <div *ngIf="quickFilterShow" class="row" style="min-height: 100px">
      <div class="card">
        <div class="card-body">
          <div class="row">

            <div class="col-sm-4">
              <label class="col-form-label" for="customerMobile">Search By Contact Number</label>
              <input class="form-control"
                     [(ngModel)]="mobileNumber"
                     id="searchMID"
                     placeholder="Enter Contact Number"
                     (focus)="fun('searchMID')"
                     (focusout)="funover('searchMID')">
            </div>

            <div class="col-md-4">
              <label class="col-form-label" for="resellerPartnerId">Status</label>
              <ng-select #filStatus [(ngModel)]="status" id="Status"
                         placeholder="Select Status" [inputAttrs]="{maxlength: '100'}"
                         (focus)="fun('Status')" (focusout)="funover('Status')">
                <ng-option value="NEW">New</ng-option>
                <ng-option value="UNDER_REVIEW">Under Review</ng-option>
                <ng-option value="ACTIVE">Active</ng-option>
                <ng-option value="SUSPENDED">Suspended</ng-option>
                <ng-option value="CLOSED">Closed</ng-option>
                <ng-option value="BLOCKED">Blocked</ng-option>
              </ng-select>
            </div>

            <div class="col-md-4">
              <label class="col-form-label" for="resellerPartnerId">KYC Status</label>
              <ng-select #filResellerPartnerId
                         [(ngModel)]="kycStatus"
                         placeholder="Select KYC Status"
                         required
                         [inputAttrs]="{maxlength: '40'}"
                         id="resellerPartnerId"
                         (focus)="fun('resellerPartnerId')"
                         (focusout)="funover('resellerPartnerId')">
                <ng-option value="Not Yet Initiated">Not Yet Initiated</ng-option>
                <ng-option value="New">New</ng-option>
                <ng-option value="Inprocess">Inprocess</ng-option>
                <ng-option value="Successful">Successful</ng-option>
                <ng-option value="Expired">Expired</ng-option>
              </ng-select>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <label class="col-form-label" for="customerEmail">Search By Email ID</label>
              <input class="form-control"
                     [(ngModel)]="emailId"
                     id="customerEmail"
                     type="text"
                     autocomplete="new-password"
                     name="customerEmail"
                     placeholder="Enter Email ID">
            </div>

            <div class="col-sm-4">
              <label class="col-form-label" for="searchWalletId">Search By Wallet ID</label>
              <input class="form-control"
                     [(ngModel)]="walletId"
                     id="searchWalletId"
                     type="text"
                     autocomplete="new-password"
                     name="searchWalletId"
                     placeholder="Enter Wallet ID"
                     (focus)="fun('searchWalletId')"
                     (focusout)="funover('searchWalletId')">
            </div>

            <div class="col-sm-4">
              <label class="col-form-label" for="searchDocumentId">Search By CNIE</label>
              <input class="form-control"
                     [(ngModel)]="documentId"
                     id="searchDocumentId"
                     type="text"
                     autocomplete="new-password"
                     name="searchDocumentId"
                     placeholder="Enter CNIE"
                     (focus)="fun('searchDocumentId')"
                     (focusout)="funover('searchDocumentId')">
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-4 d-flex align-items-end">
              <button (click)="onSearchBtnClick($event)"
                      class="btn bg-danger-custom me-2"
                      type="button"
                      style="width: 100%;">
                <i class="feather icon-search me-2"></i>Search
              </button>

              <button (click)="resetFilter()"
                      class="btn btn-secondary"
                      type="button"
                      style="width: 100%;">
                <i class="feather icon-refresh-cw me-2"></i>Reset
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Grid -->
    <div class="row mb-0" style="min-height: 470px">
      <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
        <ag-grid-angular
          [enableCellTextSelection]="true"
          (sortChanged)="onSortChange($event)"
          (filterChanged)="onFilterChange($event)"
          (filterModified)="onFilterModified($event)"
          [gridOptions]="gridOptions"
          (filterOpened)="onFilterOpened($event)"
          (gridReady)="onGridReady($event)"
          (rowClicked)="onRowClicked($event)"
          (rowDoubleClicked)="onRowDoubleClicked($event)"
          (search)="globalSearch"
          [columnDefs]="tableSelectedColumn"
          [defaultColDef]="defaultColDef"
          [paginationPageSize]="pageSize"
          [pagination]="true"
          [rowData]="rowData"
          [rowModelType]=""
          [rowSelection]="'single'"
          [suppressPaginationPanel]="true"
          style="width: 100%; height: auto;">
        </ag-grid-angular>
      </div>
    </div>

    <!-- Pagination -->
    <div class="row mt-0">
      <div class="col-4 col-xs-4 d-flex">
        <select (change)="onPageSizeChanges($event)"
                [(ngModel)]="pageSize"
                class="form-select d-flex justify-content-end col-4"
                name="pageSize"
                style="width: auto">
          <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
        </select>
        <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
      </div>

      <div class="col-8 col-xs-8">
        <ngb-pagination
          (pageChange)="onPaginationChange($event)"
          [(page)]="currentPage"
          [boundaryLinks]="true"
          [collectionSize]="collectionSize"
          [maxSize]="5"
          [pageSize]="pageSize"
          [rotate]="false"
          [directionLinks]="true"
          [ellipses]="false"
          size="sm"
          class="d-flex justify-content-end align-right">
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>

<app-modal #modalblokedCustomer [modalConfig]="modalConfigBlocked">
  <app-customer-blocked
    (closeModal)="closeModalBlocked($event)"
    [merchantStatusConfig]="tableInfo"
    [onMerchantMId]="BlockedmerchantSelectEvent">
  </app-customer-blocked>
</app-modal>

<app-modal #modalReportCustomer [modalConfig]="modalConfigReport">
  <pdf-viewer
    [src]="image"
    [rotation]="0"
    [original-size]="false"
    [show-all]="true"
    [fit-to-page]="false"
    [zoom]="1"
    [zoom-scale]="'page-width'"
    [stick-to-page]="false"
    [render-text]="true"
    [external-link-target]="'blank'"
    [autoresize]="true"
    [show-borders]="false"
    class="viewer">
  </pdf-viewer>
</app-modal>
